(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hf-shipping-goal"]) return;
  try {
    
  (() => {
    if (customElements.get('hf-shipping-goal')) return;

    const validStates = new Set([
      'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG',
      'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
    ]);

    class HFShippingGoal extends HTMLElement {
      connectedCallback() {
        this.statusElement = this.querySelector('[data-goal-status]');
        this.detailElement = this.querySelector('[data-goal-detail]');
        this.progressElement = this.querySelector('[data-goal-progress]');
        this.progressTrack = this.querySelector('[role="progressbar"]');
        this.shippingMarker = this.querySelector('[data-shipping-marker]');
        this.shippingMilestone = this.querySelector('[data-shipping-milestone]');
        this.promoMilestone = this.querySelector('[data-promo-milestone]');
        this.dialog = this.querySelector('[data-cep-dialog]');
        this.form = this.querySelector('[data-cep-form]');
        this.input = this.querySelector('[data-cep-input]');
        this.submitButton = this.querySelector('[data-cep-submit]');
        this.errorElement = this.querySelector('[data-cep-error]');
        this.openButtons = this.querySelectorAll('[data-open-cep]');
        this.closeButton = this.querySelector('[data-close-cep]');
        this.initialUnknownStatus = this.statusElement.textContent.trim();
        this.initialUnknownDetail = this.detailElement.textContent.trim();
        this.destination = this.readDestination();
        this.promoEnabled = this.dataset.promoEnabled === 'true';
        this.promoThreshold = Number(this.dataset.promoThreshold) || 250;
        this.promoDiscount = Number(this.dataset.promoDiscount) || 20;
        this.refreshSequence = 0;

        this.openButtons.forEach((button) => button.addEventListener('click', () => this.openDialog()));
        this.closeButton.addEventListener('click', () => this.dialog.close());
        this.form.addEventListener('submit', (event) => this.handleSubmit(event));
        this.input.addEventListener('input', () => this.maskCep());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });

        this.handleCartUpdate = () => this.refresh();
        ['cart:updated', 'cart:refresh', 'cart-drawer:updated', 'hf:cart-updated'].forEach((eventName) => {
          document.addEventListener(eventName, this.handleCartUpdate);
        });
        window.addEventListener('pageshow', this.handleCartUpdate);
        window.addEventListener('storage', this.handleCartUpdate);

        this.patchCartFetch();
        this.refresh();
      }

      disconnectedCallback() {
        ['cart:updated', 'cart:refresh', 'cart-drawer:updated', 'hf:cart-updated'].forEach((eventName) => {
          document.removeEventListener(eventName, this.handleCartUpdate);
        });
        window.removeEventListener('pageshow', this.handleCartUpdate);
        window.removeEventListener('storage', this.handleCartUpdate);
      }

      patchCartFetch() {
        if (window.__hfShippingGoalFetchPatched) return;
        window.__hfShippingGoalFetchPatched = true;
        const nativeFetch = window.fetch.bind(window);
        window.fetch = (...args) => nativeFetch(...args).then((response) => {
          const request = args[0];
          const url = typeof request === 'string' ? request : request?.url || '';
          if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)) {
            window.setTimeout(() => document.dispatchEvent(new CustomEvent('hf:cart-updated')), 60);
          }
          return response;
        });
      }

      readDestination() {
        try {
          const stored = JSON.parse(localStorage.getItem(this.dataset.storageKey) || 'null');
          if (stored && validStates.has(stored.uf)) return stored;
        } catch (error) {
          localStorage.removeItem(this.dataset.storageKey);
        }

        const uf = (this.dataset.defaultUf || '').toUpperCase();
        if (validStates.has(uf)) {
          return { uf, cep: (this.dataset.defaultCep || '').replace(/\D/g, '') };
        }
        return null;
      }

      writeDestination(destination) {
        this.destination = destination;
        try {
          localStorage.setItem(this.dataset.storageKey, JSON.stringify(destination));
        } catch (error) {
          return;
        }
      }

      thresholdFor(uf) {
        if (uf === 'SP' || uf === 'MG') return Number(this.dataset.thresholdSpMg);
        if (['RJ', 'ES', 'PR', 'SC', 'RS'].includes(uf)) return Number(this.dataset.thresholdSouthSoutheast);
        return Number(this.dataset.thresholdOther);
      }

      formatMoney(value) {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
      }

      async refresh() {
        this.destination = this.readDestination();

        const sequence = ++this.refreshSequence;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('cart');
          const cart = await response.json();
          if (sequence !== this.refreshSequence) return;
          const subtotalBeforeDiscount = Number(cart.original_total_price ?? cart.total_price ?? 0) / 100;
          this.renderProgress(subtotalBeforeDiscount);
        } catch (error) {
          if (sequence !== this.refreshSequence) return;
          this.renderProgress(0);
        }
      }

      renderUnknown() {
        this.statusElement.textContent = this.initialUnknownStatus;
        this.detailElement.textContent = this.initialUnknownDetail;
        this.progressElement.style.width = '0%';
        this.progressTrack.setAttribute('aria-valuenow', '0');
        this.shippingMarker.hidden = true;
        this.shippingMilestone.hidden = true;
        this.openButtons.forEach((button) => {
          button.textContent = 'Calcular';
        });
      }

      renderProgress(subtotal) {
        const promoThreshold = this.promoEnabled ? this.promoThreshold : 0;
        const shippingThreshold = this.destination ? this.thresholdFor(this.destination.uf) : 0;
        const trackThreshold = promoThreshold || shippingThreshold || 1;
        const promoRemaining = Math.max(0, promoThreshold - subtotal);
        const shippingRemaining = Math.max(0, shippingThreshold - subtotal);
        const promoQualified = promoThreshold > 0 && promoRemaining === 0;
        const shippingQualified = shippingThreshold > 0 && shippingRemaining === 0;
        const progress = Math.min(100, Math.max(0, (subtotal / trackThreshold) * 100));

        this.statusElement.textContent = this.promoEnabled
          ? `Pré-Black: ${this.promoDiscount}% OFF + frete grátis`
          : this.destination
            ? `Frete grátis para ${this.destination.uf}`
            : this.initialUnknownStatus;

        if (!this.destination) {
          this.detailElement.textContent = promoQualified
            ? `${this.promoDiscount}% OFF conquistado. Informe seu CEP para acompanhar o frete grátis.`
            : `Faltam ${this.formatMoney(promoRemaining)} para ${this.promoDiscount}% OFF. Informe seu CEP para acompanhar o frete grátis.`;
        } else if (promoQualified && shippingQualified) {
          this.detailElement.textContent = `${this.promoDiscount}% OFF e frete grátis conquistados para ${this.destination.uf}!`;
        } else if (shippingQualified) {
          this.detailElement.textContent = `Frete grátis conquistado para ${this.destination.uf}. Faltam ${this.formatMoney(promoRemaining)} para ${this.promoDiscount}% OFF.`;
        } else if (promoQualified) {
          this.detailElement.textContent = `${this.promoDiscount}% OFF conquistado. Faltam ${this.formatMoney(shippingRemaining)} para o frete grátis em ${this.destination.uf}.`;
        } else {
          this.detailElement.textContent = `Faltam ${this.formatMoney(shippingRemaining)} para frete grátis em ${this.destination.uf} e ${this.formatMoney(promoRemaining)} para ${this.promoDiscount}% OFF.`;
        }

        if (shippingThreshold > 0) {
          const markerPosition = Math.min(96, Math.max(4, (shippingThreshold / trackThreshold) * 100));
          this.shippingMarker.hidden = false;
          this.shippingMilestone.hidden = false;
          this.shippingMarker.style.left = `${markerPosition}%`;
          this.shippingMilestone.style.left = `${markerPosition}%`;
          this.shippingMilestone.textContent = `Frete ${this.formatMoney(shippingThreshold)}`;
        } else {
          this.shippingMarker.hidden = true;
          this.shippingMilestone.hidden = true;
        }

        this.promoMilestone.hidden = !this.promoEnabled;
        this.promoMilestone.textContent = `${this.promoDiscount}% OFF`;
        this.progressElement.style.width = `${progress}%`;
        this.progressTrack.setAttribute('aria-valuemax', String(trackThreshold));
        this.progressTrack.setAttribute('aria-valuenow', String(Math.min(subtotal, trackThreshold).toFixed(2)));
        this.openButtons.forEach((button) => {
          button.textContent = this.destination ? 'Alterar CEP' : 'Calcular CEP';
        });
      }

      openDialog() {
        this.errorElement.hidden = true;
        this.errorElement.textContent = '';
        const cep = this.destination?.cep || '';
        this.input.value = cep.length === 8 ? `${cep.slice(0, 5)}-${cep.slice(5)}` : cep;
        this.dialog.showModal();
        window.setTimeout(() => this.input.focus(), 0);
      }

      maskCep() {
        const digits = this.input.value.replace(/\D/g, '').slice(0, 8);
        this.input.value = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
      }

      async handleSubmit(event) {
        event.preventDefault();
        const cep = this.input.value.replace(/\D/g, '');
        if (cep.length !== 8) {
          this.showError('Digite um CEP válido com 8 números.');
          return;
        }

        const originalLabel = this.submitButton.textContent;
        this.submitButton.disabled = true;
        this.submitButton.textContent = 'Consultando...';
        this.errorElement.hidden = true;

        try {
          const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`, {
            headers: { Accept: 'application/json' },
            referrerPolicy: 'no-referrer'
          });
          if (!response.ok) throw new Error('lookup');
          const address = await response.json();
          const uf = String(address.uf || '').toUpperCase();
          if (address.erro || !validStates.has(uf)) throw new Error('invalid');
          this.writeDestination({ cep, uf });
          await this.refresh();
          this.dialog.close();
        } catch (error) {
          this.showError('Não foi possível localizar esse CEP. Confira os números e tente novamente.');
        } finally {
          this.submitButton.disabled = false;
          this.submitButton.textContent = originalLabel;
        }
      }

      showError(message) {
        this.errorElement.textContent = message;
        this.errorElement.hidden = false;
        this.input.focus();
      }
    }

    customElements.define('hf-shipping-goal', HFShippingGoal);
  })();

  } catch(e) { console.error(e); }
})();
})();
